let language = {
    // 
    STORE_ORDERS_EMPTY_STORE_1: "你还没有商店，请到",
    STORE_ORDERS_EMPTY_STORE_2: "商店",
    STORE_ORDERS_EMPTY_STORE_3: ", 创建一个新店。",
    
    // 
    STORE_ORDERS_ORDER_NUMBER_SEARCH_LABEL: "订单号:",
    STORE_ORDERS_ORDER_DATE_SEARCH_LABEL: "订单时间:",

    STORE_ORDERS_SEARCH_BTN_TEXT: "搜索",
    STORE_ORDERS_RESET_BTN_TEXT: "重置",
    
    // 
    STORE_ORDERS_IS_EMPTY: "商店订单是空的",
    
    // 
    STORE_ORDERS_SEARCH_EMPTY: "找不到符合指定条件的订单。请修改搜索条件后再试。",
    
    // 
    STORE_ORDERS_NOT_STORE_INFO_ALERT_TITLE: "商店信息丢失",
    STORE_ORDERS_NOT_STORE_INFO_ALERT_CONTENT: "当前商店不存在。",
    
    STORE_ORDERS_ORDER_DATE_ERROR_TIP: "开始日期必须小于结束日期",
};

export { language }